import { getProductsInProductImpressionFormat } from '@/helpers/product'
import {
  notifyExternalServices,
  ACTIONS,
} from '@/services/external-communication/external-communication'
import { CONTEXTS } from '@/config/constants'

export const reportPromoCardImpression = filteredPromoCards => {
  const promotions = filteredPromoCards.map(card => ({
    name: card.identifier,
    creative: card.imageUrl,
    position: CONTEXTS.promoCard,
  }))

  if (promotions.length > 0) {
    notifyExternalServices({
      action: ACTIONS.promotionView,
      promotions,
    })
  }
}

export const reportLoadingOfProducts = filteredCards => {
  if (filteredCards.length) {
    notifyExternalServices({
      action: ACTIONS.listView,
      productData: {
        items: getProductsInProductImpressionFormat(filteredCards),
      },
    })
  }
}
